import {
  GET_LIST_DANHSACHKHACHHANG,
  GET_LIST_DANHSACHKHACHHANG_SUCCESS,
  GET_LIST_DANHSACHKHACHHANG_FAILURE,
} from "./actionTypes";

export const getListDanhSachKhachHang = (dataSearch) => ({
  type: GET_LIST_DANHSACHKHACHHANG,
  dataSearch,
});

export const getListDanhSachKhachHangSuccess = (data) => ({
  type: GET_LIST_DANHSACHKHACHHANG_SUCCESS,
  payload: data,
});

export const getListDanhSachKhachHangFailure = () => ({
  type: GET_LIST_DANHSACHKHACHHANG_FAILURE,
});
